import { ErrorHandler } from '@angular/core';
import { AbstractLogger } from '@mobilejazz/harmony-core';

export class AppErrorHandler extends ErrorHandler {
    constructor(protected logger: AbstractLogger, protected isProduction: boolean) {
        super();
    }

    handleError(error) {
        const originalError = error?.rejection ?? error?.ngOriginalError ?? error;

        this.logger.error(
            'AppErrorHandler',
            `Unhandled error: ${originalError?.message || String(originalError)}\nStack: ${
                originalError?.stack || 'No stack trace available'
            }`,
        );

        if (!this.isProduction) {
            console.error(`[AppErrorHandler] ${error}`);
        }

        super.handleError(error);
    }
}
